import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import cognitoService from 'services/cognitoService';

const SecuritySettings = ({ onUpdate }) => {
  const location = useLocation();

  const [showPasswordForm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(
    Boolean(location.state?.passwordChanged)
  );

  // Clear navigation state so success message does not reappear on refresh
  useEffect(() => {
    if (location.state?.passwordChanged) {
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  return (
    <div className="rounded-lg border border-border bg-background/50 p-4 md:p-5 transition-smooth">
      <div className="flex items-center gap-3 mb-4">
        <div className="flex items-center justify-center w-10 h-10 bg-error/10 rounded-lg">
          <Icon name="Shield" size={20} color="var(--color-error)" />
        </div>
        <div>
          <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
            Alterar Senha
          </h3>
        </div>
      </div>

      {showSuccess && (
        <div className="mb-4 md:mb-6 p-4 bg-success/10 border border-success/20 rounded-md flex items-start gap-3">
          <Icon
            name="CheckCircle"
            size={20}
            color="var(--color-success)"
            className="flex-shrink-0 mt-0.5"
          />
          <div>
            <p className="text-sm font-medium text-success font-body">
              Senha alterada com sucesso!
            </p>
            <p className="text-xs text-success/80 mt-1">
              Use sua nova senha no próximo login.
            </p>
          </div>
        </div>
      )}

      <div className="space-y-4">
        <div>
          <div className="flex items-center justify-between mb-4">
            {!showPasswordForm && (
              <Button
                variant="outline"
                size="sm"
                iconName="Edit"
                iconPosition="left"
                onClick={() => cognitoService.changePassword()}
              >
                Alterar Senha
              </Button>
            )}
          </div>
          <p className="text-sm text-muted-foreground font-body mt-1">
            Após informar o e-mail cadastrado no sistema, você receberá um código nesse e-mail. Você deverá informar esse código juntamente com a nova senha.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SecuritySettings;
